import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75 8a.74.74 0 0 1-.75.75H8.75V14a.75.75 0 0 1-1.5 0V8.75H2a.75.75 0 0 1 0-1.5h5.25V2a.75.75 0 0 1 1.5 0v5.25H14a.75.75 0 0 1 .75.75Z';
const draw24px =
  'M19.75,12a.75.75,0,0,1-.75.75H12.75V19a.75.75,0,0,1-1.5,0V12.75H5a.75.75,0,0,1,0-1.5h6.25V5a.75.75,0,0,1,1.5,0v6.25H19A.76.76,0,0,1,19.75,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PlusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'plus'),
) as IconWithRender;

PlusIcon.displayName = 'PlusIcon';
PlusIcon.propTypes = Icon.propTypes;
PlusIcon.renderIcon = (props) => <PlusIcon {...props} />;
export default PlusIcon;
